/*
 The class used to encapsulate PreChat specific logic to show and hide messages and hanlde state management 
 */
import MessageHandler from './MessageHandler';
import WidgetTypes from '../core/enums/WidgetTypes';
import { ScriptsQuestionType } from '../core/enums/Enum';
import WebStorage from '../core/hooks/WebStorage';

export default class PreChatMessageHandler extends MessageHandler {
    constructor(options) {
        super(options);
        this.options = Object.assign(options, {
            objectType: WidgetTypes.PreChatMessageHandler
        });

        this.options.wrap = true; // create a wrapper div; use targetElement instead queried through targetElementSelector
        this.options.targetElementSelector = '#apexchat_prechat_message_popup_container'; // '#apexchat_prechat_message';//this will be the placeholder for all messages to render
        this.options.renderOninit = false; /* with this we stop auto-rendering and give the control to the caller(i.e. PreChatMessageHandler) to take care of rendering: in this case QuestionTypeRenderer */
        // reset storageAPI to use sessionStorage
        this.storageAPI = WebStorage({ type: 'session' });
        ApexChat.sessionAPI = this.storageAPI;

        this.loadAll(); // this will fetch the cashed messages from sessionStorage and parse them back and put them in this.messages; also render them
    }

    /* @param {any} model
     * used to show and save new messages
     summary: push actually takes model and call its parent push function which does whole job.. */
    push(model) {
        // push is not array push, its taking model as argument and doing several tasks.
        const template = this.getTemplate(model.messageType); // for now it does not matter for QR types
        this.options.renderOninit = model.questionType == ScriptsQuestionType.None; // render plain text messages or else let something else render it; e.g. questionTypeRenderer

        super.push(
            Object.assign(model, {
                template: this.messageTemplate || model.template,
                userId: model.userId || 0,
                participantDisplayName: model.participantDisplayName || '',
                createdOn: new Date()
            })
        );
        this.saveAll();
    }

    // a must-call method before push()
    setMessageTemplate(template) {
        this.messageTemplate = template;
    }

    // currently this is void; we are using this.messageTemplate already
    getTemplate(messageType) {
        const template = null;
        return template;
    }

    /* summary: returns the last msg view object frequently used for
     * taking previous msg in prechat to animate its html in unique style.
     */
    getLastMessage() {
        // returns view of LastMsg
        for (let i = 0; i < this.messages.length; i++) {
            if (this.messages[i].isLastMessage) {
                return this.messages[i];
            }
        }
    }

    getFirstMessage() {
        for (let i = 0; i < this.messages.length; i++) {
            if (this.messages[i].isFirstMessage) {
                return this.messages[i];
            }
        }
    }

    saveAll() {
        this.storageAPI.Store('livechat_prechat_messages_store', JSON.stringify(this.messages));
    }

    // makes sense only in reload scenarios
    loadAll() {
        const self = this;
        const cache = this.storageAPI.Get('livechat_prechat_messages_store');
        this.messages = cache ? JSON.parse(cache) : this.messages;
        const _render = function (messageObj) {
            messageObj.isFromHistory = true;
            self.push(messageObj);
        };

        for (let i = 0; i < self.messages.length; i++) {
            if (self.isChatActive() && self.isPageRefreshed()) {
                if (i == self.messages.length - 1) {
                    // TODO: When Chat is started and is in progress, If the Prechat message is appeared doesnt remain appeared.
                    // _render(this.messages[i]);
                }
            }
        }
    }
}
